import React from 'react';

const FilledFlag = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='16'
      viewBox='0 0 12 16'
      fill='none'
    >
      <path
        d='M0.58 0C0.9 0 1.16 0.25 1.16 0.56V1.37L2.38 1.13C3.77 0.86 5.21 0.99 6.52 1.50L6.68 1.56C7.77 1.98 8.98 2.06 10.12 1.78C11.08 1.55 12 2.25 12 3.19V8.67C12 9.41 11.48 10.05 10.74 10.23L10.57 10.27C9.08 10.63 7.51 10.52 6.09 9.98C4.98 9.55 3.77 9.44 2.61 9.67L1.16 9.95V15.44C1.16 15.75 0.90 16 0.58 16C0.26 16 0 15.75 0 15.44V0.56C0 0.25 0.26 0 0.58 0Z'
        fill='#F3223C'
      />
    </svg>
  );
};

export default FilledFlag;
